import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-169ddca7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
const _hoisted_3 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "space-between"
  }
};
import { ref, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRouter } from 'vue-router';
import DongleModule from './components/dongleModule';
import TableComponent from './components/Table';
import { getModuleConfig, delModuleMenuByConfigId } from '@/api/authModule';
import usePagination from '@/hooks/usePagination';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);

    // loading效果
    const loading = ref(false);
    const {
      currentPage,
      total,
      pageSize,
      setPageSize,
      setCurrentPage,
      setTotal
    } = usePagination();

    /**
     * 获取短信接入方密钥分页
     */
    const getData = async () => {
      loading.value = true;
      const res = await getModuleConfig({
        types: [3]
      });
      setTotal(res.total);
      tableData.value = res.records;
      loading.value = false;
      loading.value = false;
    };

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };
    const handleChangeSize = e => {
      setPageSize(e);
      getData();
    };
    const dongleModuleVisible = ref(false);
    const handleAddRow = () => {
      dongleModuleVisible.value = true;
    };
    const current = ref(null);
    const handleUpdate = async row => {
      current.value = JSON.parse(JSON.stringify(row));
      dongleModuleVisible.value = true;
    };
    const handleDel = async row => {
      ElMessageBox.confirm('是否确认删除该条类别', '确认删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delModuleMenuByConfigId(row.id);
        getData();
        ElMessage.success('删除成功');
      });
    };
    const router = useRouter();
    const handleJumpInfo = row => {
      // /application/identAuth/dongleUserModuleManage/moduleDetail/:id
      router.push(`/application/identAuth/dongleUserModuleManage/moduleDetail/${row.id}`);
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        class: "title-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddRow
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(_unref(TableComponent), {
          onUpdate: handleUpdate,
          onDel: handleDel,
          onInfo: handleJumpInfo,
          tableData: tableData.value,
          loading: loading.value
        }, null, 8, ["tableData", "loading"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleChangeSize,
          "page-sizes": [12, 24, 36],
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, sizes, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(DongleModule), {
        modelValue: dongleModuleVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dongleModuleVisible.value = $event),
        model: current.value,
        onRefreshData: getData,
        onClearModel: _cache[1] || (_cache[1] = $event => current.value = null)
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};